import React, { CSSProperties } from 'react';
import { ModalContext } from './ModalContextProvider';

type ModalFooterProps = {
  /** The button components to render inside the footer */
  children: React.ReactNode;

  /** Custom footer style, add when needed */
  footerStyle?: CSSProperties;
};

/** A footer that renders 1-3 buttons in the order given, to be used within a `<Modal />` component */
const ModalFooter: React.FC<ModalFooterProps> = ({ children, footerStyle }) => {
  const { setHasFooter } = React.useContext(ModalContext);

  React.useEffect(() => {
    setHasFooter(true);
  }, []);

  return (
    <>
      {React.Children.count(children) === 1 && (
        <footer
          className="modal-footer"
          style={{
            ...footerStyle,
            justifyContent: 'flex-end',
          }}
        >
          {children}
        </footer>
      )}
      {React.Children.count(children) === 2 &&
        (() => {
          const childrenArray = React.Children.toArray(children);
          return (
            <footer
              className="modal-footer"
              css={{
                ...footerStyle,
                justifyContent: 'space-between',
              }}
            >
              {childrenArray[0]}
              {childrenArray[1]}
            </footer>
          );
        })()}
      {React.Children.count(children) === 3 &&
        (() => {
          const childrenArray = React.Children.toArray(children);
          return (
            <footer
              css={{
                ...footerStyle,
                justifyContent: 'space-between',
              }}
            >
              {childrenArray[0]}
              <div
                css={{
                  '& :first-of-type': {
                    marginRight: '16px',
                  },
                }}
              >
                {childrenArray[1]}
                {childrenArray[2]}
              </div>
            </footer>
          );
        })()}
    </>
  );
};

export default ModalFooter;
